// Centralized feature matrix for pricing plans
// Usage: import { isFeatureEnabled, featureMatrix } from "./featureMatrix";
// plans: "test", "large", "free", "cancelled", "basic", "small", "full"

/**
 * @typedef {Object} ZweefGlobal
 * @property {string} zweefplan
 */

// Map legacy/alias plans to main plans
export const planAlias = {
  free: "full",
  test: "full",
  large: "small",
  cancelled: "cancelled",
};

// Main feature matrix
export let featureMatrix = {
  basic: {
    key: "basic",
    title: "Basisplan", // $t('Basisplan'),
    description: "Dagelijkse aanmelding, emails en DTO administratie", //  $t('Dagelijkse aanmelding, emails en DTO administratie')
    flights: false,
    financial: false,
  },
  small: {
    key: "small",
    title: "Vluchtplan", // $t('Vluchtplan'),
    description: "Basisplan + Vluchtregistratie en EASA recency", //  $t('Basisplan + Vluchtregistratie en EASA recency')
    flights: true,
    financial: false,
  },
  full: {
    key: "full",
    title: "Financieelplan", // $t('Financieelplan'),
    description: "Vluchtplan + Financieelbeheer", //   $t('Vluchtplan + Financieelbeheer')
    flights: true,
    financial: true,
  },
};

export const pricePlans = Object.values(featureMatrix);

export function isFeatureEnabled(feature) {
  // @ts-ignore
  let plan = window.zweefplan || "small";
  plan = planAlias[plan] || plan;
  return featureMatrix[plan]?.[feature] ?? false;
}

// Replace clubHasFlight constant with a function
export function clubHasFlight() {
  return isFeatureEnabled("flights");
}

export function clubHasFinance() {
  return isFeatureEnabled("financial");
}
